"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronDayOfWeek = exports.ReportExportFormatStr = exports.ReportExportFormat = exports.ReportDeliveryType = exports.RecurrencePeriod = void 0;
var RecurrencePeriod;
(function (RecurrencePeriod) {
    RecurrencePeriod["Monthly"] = "Monthly";
    RecurrencePeriod["Weekly"] = "Weekly";
    RecurrencePeriod["Daily"] = "Daily";
    RecurrencePeriod["Hourly"] = "Hourly";
})(RecurrencePeriod || (exports.RecurrencePeriod = RecurrencePeriod = {}));
var ReportDeliveryType;
(function (ReportDeliveryType) {
    ReportDeliveryType[ReportDeliveryType["Email"] = 0] = "Email";
    ReportDeliveryType[ReportDeliveryType["ApiOrUrl"] = 1] = "ApiOrUrl";
    ReportDeliveryType[ReportDeliveryType["Webhook"] = 2] = "Webhook";
})(ReportDeliveryType || (exports.ReportDeliveryType = ReportDeliveryType = {}));
var ReportExportFormat;
(function (ReportExportFormat) {
    ReportExportFormat[ReportExportFormat["CSV"] = 0] = "CSV";
    ReportExportFormat[ReportExportFormat["JSON"] = 1] = "JSON";
})(ReportExportFormat || (exports.ReportExportFormat = ReportExportFormat = {}));
var ReportExportFormatStr;
(function (ReportExportFormatStr) {
    ReportExportFormatStr["CSV"] = "csv";
    ReportExportFormatStr["JSON"] = "json";
})(ReportExportFormatStr || (exports.ReportExportFormatStr = ReportExportFormatStr = {}));
var CronDayOfWeek;
(function (CronDayOfWeek) {
    CronDayOfWeek[CronDayOfWeek["Sunday"] = 0] = "Sunday";
    CronDayOfWeek[CronDayOfWeek["Monday"] = 1] = "Monday";
    CronDayOfWeek[CronDayOfWeek["Tuesday"] = 2] = "Tuesday";
    CronDayOfWeek[CronDayOfWeek["Wednesday"] = 3] = "Wednesday";
    CronDayOfWeek[CronDayOfWeek["Thursday"] = 4] = "Thursday";
    CronDayOfWeek[CronDayOfWeek["Friday"] = 5] = "Friday";
    CronDayOfWeek[CronDayOfWeek["Saturday"] = 6] = "Saturday";
})(CronDayOfWeek || (exports.CronDayOfWeek = CronDayOfWeek = {}));
//# sourceMappingURL=reports_scheduled_job.js.map